// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Import your pages
import Home from './pages/Home';
import About from './pages/About';
import FormPage from './pages/FormPage';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Account from './pages/Account';
import ComingSoon from './pages/ComingSoon';

// Import the Navbar
import Navbar from './components/Navbar';
import BackgroundAnimation from './components/BackgroundAnimation';

// AuthContext
import { useAuth } from './context/AuthContext';

// PrivateRoute: Only if logged in
function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

// PublicRoute: Only if logged out
function PublicRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/account" /> : children;
}

// EngineerRoute: Must be logged in AND role === 'engineer'
function EngineerRoute({ children }) {
  const { currentUser, userRole } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  if (userRole !== 'engineer') return <Navigate to="/account" />;
  return children;
}

function App() {
  return (
    <Router>
      <div className="app-container">

        {/* Background Animation */}
        <BackgroundAnimation></BackgroundAnimation>

        {/* The new Navbar imported as a separate component */}
        <Navbar />

        <div className="page-content">
          <Routes>
            {/* Public routes (only if logged out) */}
            <Route
              path="/signup"
              element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route path="/coming-soon" element={<ComingSoon />} />

            {/* Private route for /account */}
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <Account />
                </PrivateRoute>
              }
            />

            {/* Engineer-only route for /form */}
            <Route
              path="/form"
              element={
                <EngineerRoute>
                  <FormPage />
                </EngineerRoute>
              }
            />

            {/* Always public */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>

      </div>
    </Router>
  );
}

export default App;
